import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

const MoreIconHorizontalSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28">
        <path fill="currentColor" d="M7.5 13a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM5 14.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zm9.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM12 14.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zm9.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM19 14.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0z"></path>
    </svg>
)
const MoreHorizontalIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {MoreIconHorizontalSvg}
    </SvgIcon>
);
export default MoreHorizontalIcon
